// extracted by mini-css-extract-plugin
export default {"card":"WhyChooseUsItem_card__kJuBq","cardTitle":"WhyChooseUsItem_cardTitle__UVRoh","cardText":"WhyChooseUsItem_cardText__cyFki"};